import React, {Component} from 'react'
import {Input, InputGroup, InputGroupAddon, Button, FormGroup} from 'reactstrap'
import {AvForm, AvInput, AvGroup, AvFeedback} from 'availity-reactstrap-validation'
import PropTypes from 'prop-types'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Mutation} from 'react-apollo'
import {toast} from 'react-toastify'

import addProjectBudgetBreakdownsMutation from '../../queries/server/mutations/add_project_budget_breakdowns'
import editProjectLocalMutation from '../../queries/client_side/mutations/edit_project'

class ProjectBudgetBreakdownInput extends Component {

    constructor(props) {
        super(props)

        this.form = null
        this.state = {
            description: props.description || '',
            amount: props.amount || ''
        }

    }

    reset = () => {
        this.setState({description: '', amount: ''})
        this.form.reset()
    }

    render() {
        const {project_id, parent_id, id, onAdded, onCancel, successMessage} = this.props
        const {description, amount} = this.state
        return (
            <Mutation mutation={addProjectBudgetBreakdownsMutation}>
                {(addProjectBudgetBreakdownsMutationFunc, {loading}) => (
                    <Mutation mutation={editProjectLocalMutation}>
                        {(editProjectLocalMutationFunc) => (
                            <AvForm
                                ref={ref => this.form = ref}
                                className="d-flex flex-row" style={{flex: '1'}}
                                onValidSubmit={() => {
                                    addProjectBudgetBreakdownsMutationFunc(
                                        {
                                            variables: {
                                                project_id,
                                                parent_project_activity_budget_id: parent_id,
                                                data: [
                                                    {
                                                        id: id || null,
                                                        description,
                                                        amount
                                                    }
                                                ]
                                            }
                                        }
                                    )
                                        .then(({data}) => {
                                            editProjectLocalMutationFunc({variables: {data: data.upsertProjectBudgetBreakdowns}})
                                            toast.success(successMessage, {autoClose: 2000})
                                            this.reset()
                                            if (onAdded) onAdded()
                                        })
                                        .catch(e => toast.error(e.message, {autoClose: false}))
                                }}
                            >
                                <div className="d-flex mr-2" style={{flex: '1'}}>
                                    <AvInput
                                        required
                                        name="detail"
                                        className="form-control-sm"
                                        placeholder="Detail"
                                        value={description}
                                        onChange={(evt) => this.setState({description: evt.target.value})}
                                    />
                                </div>
                                <div className="d-flex mr-2">
                                    <AvGroup>
                                        <InputGroup className="input-group-sm">
                                            <InputGroupAddon addonType="prepend">£</InputGroupAddon>
                                            <AvInput
                                                required
                                                name="amount"
                                                placeholder="Amount"
                                                type="text"
                                                className="text-right"
                                                value={amount}
                                                onChange={(evt) => this.setState({amount: evt.target.value})}
                                            />
                                        </InputGroup>
                                    </AvGroup>
                                </div>
                                <div className="d-flex flex-row">

                                    <Button
                                        color="secondary"
                                        size="sm"
                                        className="mr-1 square-btn"
                                        onClick={() => {
                                            if (onCancel) onCancel()
                                        }}
                                    >
                                        <FontAwesomeIcon color="#fff" icon="times"/>
                                    </Button>


                                    <Button
                                        color="success"
                                        size="sm"
                                        disabled={loading}
                                        className="square-btn"
                                    >
                                        <FontAwesomeIcon color="#fff" icon="save"/>
                                        {loading && 'Saving...'}
                                    </Button>


                                </div>
                            </AvForm>
                        )}
                    </Mutation>
                )}

            </Mutation>
        )
    }


}

ProjectBudgetBreakdownInput.propTypes = {
    project_id: PropTypes.string.isRequired,
    parent_id: PropTypes.number.isRequired,
    id: PropTypes.number,
    description: PropTypes.string,
    amount: PropTypes.number,
    onAdded: PropTypes.func,
    onCancel: PropTypes.func,
    successMessage: PropTypes.string
}

export default ProjectBudgetBreakdownInput